import { MAX_CREDITS_PER_ORDER } from 'constants/shop';
import Modal from 'honeydew/Modal';

function CreditsInfoModal({ open, setOpen }) {
    return (
        <Modal headline="Credits" open={open} onClose={() => setOpen(false)}>
            <h3 className="text-body-sm mb-10 font-grotesk-bold">How do I spend my credits?</h3>
            <p className="text-body-sm">
                Your credit balance will be automatically applied to the purchase of your next order(s) until they are
                exhausted or expired. A max of ${MAX_CREDITS_PER_ORDER} in credits may be applied to any single order.
                If your credits do not cover the cost of your entire order, the remaining balance will be charged to
                your credit card on file. Credits will only be applied to orders that are fulfilled and not to donated
                or skipped orders. Credits cannot be applied to purchases of alcoholic beverages or gift cards. Our
                system will apply the credits in the order of soonest to latest expirations.
            </p>
            <h3 className="text-body-sm mt-20 mb-10 font-grotesk-bold">Do my credits expire?</h3>
            <p className="text-body-sm">
                Most credits have an expiration date and can be viewed on your account page under &lsquo;Credits&rsquo;.
                If a credit expires before an order is charged, the credit cannot be used. If a credit expires within 30
                days of its redemption, but the order it&apos;s applied to is ultimately refunded, we will apply a new
                courtesy expiration date to those credits that are 30 days from the date of refund.
            </p>
        </Modal>
    );
}

export default CreditsInfoModal;
